import { Tags } from '@kibsi/ks-ui-types'
import type { Tag } from '../../model/tag'

export function tagsFromDto(tags: Map<string, Tag>, dto: Tags): void {
    tags.clear()
    dto.tags?.forEach((tag) => {
        tags.set(tag.tagId, tag)
    })
}
